import styled from 'styled-components';

const Wrapper = styled('div')`
	display: flex;
	align-items: center;
	margin-top: 4px;
`;

const Position = styled('span')`
	flex: 0 0 24px;
	font-weight: bold;
	font-size: 12px;
	line-height: 16px;
`;

const Label = styled('div')`
	font-weight: 500;
	font-size: 12px;
	line-height: 16px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export {
	Wrapper,
	Position,
	Label,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Item/ItemInfo/styles.ts